/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import styles from './fader.module.css' with {type: 'css'};
import html from './fader.module.html';

export class LinearFader extends HTMLElement {

    static readonly ELEMENT = "linear-fader";

    static DefineElement() {
        if (customElements.get(LinearFader.ELEMENT) === undefined) {
            customElements.define(LinearFader.ELEMENT, LinearFader);
        }
    }

    static observedAttributes = [
        'min',
        'max',
        'value'
    ];

    // all of the HTML elements for the instrument are contained within a shadow DOM
    private root : ShadowRoot;

    private fader : HTMLInputElement;


    constructor() {
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.root.adoptedStyleSheets.push(styles);
        this.root.innerHTML = html;
        this.fader = this.root.querySelector('#fader') as HTMLInputElement;
    }

    connectedCallback() {
        this.fader.addEventListener('input', e => {
            console.log(this.fader.value)
        });
    } 


    disconnectedCallback() { }

    /**
     * When an attribute is changed on our custom component, this gets fired...
     */
    attributeChangedCallback(name : string, oldValue : string, newValue : string) {
        if (name === 'min') {
            this.fader.setAttribute('min', newValue);
        } else if (name === 'max') {
            this.fader.setAttribute('max', newValue);
        } else if (name === 'value') {
            this.fader.setAttribute('value', newValue);
        }
    }


    /**
     * Fire custom events whenever the value is changed by the user
     */
    private emitEvent(name : string) {
        this.dispatchEvent(
            new CustomEvent(name, { 
                bubbles: true,
                composed: true,
                detail: {
                    origin : this,
                    value : this.fader.value
                }
            })
        );
    }
}
